import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { AlertService } from '../../services/alert.service';
import { MdlCall } from '../../components/mdl-call/mdl-call';
import { MdlTask } from '../../components/mdl-task/mdl-task';
import { MdlEvent } from '../../components/mdl-event/mdl-event';
import { MdlManageProspect } from '../../components/mdl-manage-prospect/mdl-manage-prospect';
import { CommonModule } from '@angular/common';
import { MdlChangeOwnerComponent } from '../../components/mdl-change-owner/mdl-change-owner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { NavOpportunities } from '../../components/opportunities/nav-opportunities/nav-opportunities';
import { MdlManageOportunity } from '../../components/mdl-manage-opportunity/mdl-manage-opportunity';
import { MdlSelectCompanyType } from '../../components/mdl-public-private/mdl-public-private';
import { FormsModule } from '@angular/forms';
import { OpportunitiesGeneral } from '../opportunities-generalview-table/opportunities-generalview-table';
import { MdlManageGoals } from '../../components/mdl-manage-goals/mdl-manage-goals';
import { log } from 'node:console';
import { jwtDecode } from 'jwt-decode';
import { MdlChangestatuscomponent } from '../../components/mdl-change-taskStatus/mdl-change-taskStatus';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { response } from 'express';
import { MdlmanageContract } from '../../components/mdl-manage-contract/mdl-manage-contract';
import { MdlChangeContractStatus } from '../../components/mdlContract-status-reminder/mdlContract-status-reminder';
import { MdlChangeOwnerContractComponent } from '../../components/mdl-change-contractOwner/mdl-change-contractOwner';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-contract',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    FormsModule,
    MatDialogModule,
  ],
  templateUrl: './contract.html',
  styleUrls: ['./contract.css'],
})
export class Contract implements OnInit {
  ngOnInit(): void {}

  constructor(
    private api: Api,
    private elementRef: ElementRef,
    private router: Router,
    private alertService: AlertService,
    public permissionService: PermissionService,
    
  ) {
    this.cargarcontratos();
  }

 public searchTerm: string = '';
public contratos: any[] = [];
public contratosfiltrados: any[] = [];
public sortColumn: string = '';
  isLoading: boolean = true;
  errorMessage: string = '';
  showRecentDropdown: boolean = false;
  openedMenuId: string | null = null;
  selectedItem: string = 'todas';
  contratosSeleccionados = 0;
  showActionsDropdown = false;
  selectedContract: string[] = [];
  readonly dialog = inject(MatDialog);

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  toggleRecentDropdown(): void {
    this.showRecentDropdown = !this.showRecentDropdown;
  }

  selectItem(key: string): void {
    this.selectedItem = key;
    this.filterContracts();
    this.showRecentDropdown = false;
  }

  toggleActionsDropdown() {
    this.showActionsDropdown = !this.showActionsDropdown;
  }

  ejecutarAccion(accion: string) {
    console.log(`Acción ejecutada: ${accion}`);
    this.showActionsDropdown = false;

    if (accion === 'eliminar') {
      if (this.selectedContract.length === 0) {
        console.warn('No hay contratos seleccionados para borrar');
        return;
      }

      const dialogRef = this.dialog.open(MdlDelete, {
        minWidth: '400px',
        maxHeight: '600px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'contracts',
          ids: this.selectedContract,
        },
      });
    }

    if (accion === 'estado') {
      this.dialog.open(MdlChangeContractStatus, {
        minWidth: '450px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'estado',
          ids: this.selectedContract,
        },
      });
    }

    if (accion === 'asignar') {
      this.dialog.open(MdlChangeContractStatus, {
        minWidth: '450px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'recordatorio',
          ids: this.selectedContract,
        },
      });
    }
  }

  onCheckboxChange(event: any, contractId: string) {
    if (event.target.checked) {
      this.selectedContract.push(contractId);
    } else {
      this.selectedContract = this.selectedContract.filter(
        (id) => id !== contractId
      );
    }

    this.contratosSeleccionados = this.selectedContract.length;
  }

  cargarcontratos() {
    this.api.showLoading();
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getcontracts().subscribe({
      next: (response: any) => {
        this.contratos = (response.contratos || response).map(
          (contrato: any) => ({
            ...contrato,
            id: contrato.contrato_id || contrato.id,
          })
        )   .sort(
          (a:any, b:any) =>
            Number(b.numero_contrato) - Number(a.numero_contrato) 
        );

        this.contratosfiltrados = [...this.contratos];

        setTimeout(() => {
          this.api.hideLoading();
          this.isLoading = false;
        }, 500);
      },
      error: (error: any) => {
        console.error('Error al cargar tareas:', error);
      },
    });
  }

  filterContracts(): void {
    let userId = '';

    const token = localStorage.getItem('token');
    if (token) {
      const decoded: any = jwtDecode(token);
      userId = decoded.userId ?? decoded.usuario_id ?? '';
    }

    switch (this.selectedItem) {
      case 'todos':
        this.contratosfiltrados = [...this.contratos];
        break;

      case 'propios':
        this.contratosfiltrados = this.contratos.filter(
          (c) => c.oportunidades?.cuenta?.ejecutivo_id === userId
        );
        break;

      default:
        this.contratosfiltrados = [...this.contratos];
        break;
    }
  }

  openMdlCreateContract() {
    this.dialog.open(MdlmanageContract, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create',
      },
    });
  }

  openmdlupdateContract(data: any) {
    console.log('Click');
    this.dialog.open(MdlmanageContract, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'edit',
        contrato: data,
      },
    });
  }

  openmdldeleteContract(id: string): void {
    this.dialog.open(MdlDelete, {
      minWidth: '400px',
      maxHeight: '600px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'contracts',
        ids: [id],
      },
    });
  }

  openmdlUpdateStatus(id: string): void {
    this.dialog.open(MdlChangeContractStatus, {
      minWidth: '450px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'recordatorio',
        ids: [id],
      },
    });
  }

  openmdlUpdateReminder(id: string): void {
    this.dialog.open(MdlChangeContractStatus, {
      minWidth: '450px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'estado',
        ids: [id],
      },
    });
  }

  private esUUIDValido(id: string): boolean {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(id);
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;

    const clickedInsideRecent = this.elementRef.nativeElement
      .querySelector('.dropdown-trigger')
      ?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement
      .querySelector('.dots-button')
      ?.contains(target);

    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }

    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }

  verDetalleContrato(id: string, event?: MouseEvent): void {
    console.log('📦 ID recibido:', id);

    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox =
        target.tagName === 'INPUT' &&
        target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;

      if (isCheckbox || isDropdown) {
        return;
      }
    }

    if (!id || !this.esUUIDValido(id)) {
      this.alertService.error('ID inválido', 'ID de contrato no válido');
      return;
    }

    this.router.navigate(['contracts', id]).then((navigationResult) => {
      if (!navigationResult) {
        this.alertService.error('Error de navegación', 'No se pudo cargar el detalle del contrato');
        console.error('Error de navegación a contract/', id);
      }
    });
  }

  openChangeOwnerModal(contrato: any): void {
  const dialogRef = this.dialog.open(MdlChangeOwnerContractComponent, {
    minWidth: '600px',
    maxHeight: '90vh',
    panelClass: 'mat-dlg-class',
    data: { contrato }, 
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      console.log('Cambio de propietario realizado:', result);
      this.cargarcontratos();
    } else {
      console.log('Modal cerrado sin cambios');
    }
  });
}

  actualizarTabla(): void {
    this.cargarcontratos();
    this.alertService.success('Tabla actualizada', 'La tabla ha sido actualizada');
  }

  onSearchChange(): void {
  const search = this.searchTerm?.toLowerCase().trim();

  if (!search) {
    this.contratosfiltrados = [...this.contratos];
  } else {
    this.contratosfiltrados = this.contratos.filter((contrato: any) => {
      const cuenta = contrato.oportunidades?.cuenta;
      const ejecutivo = cuenta?.ejecutivo;

      return (
        contrato.numero_contrato?.toLowerCase().includes(search) ||
        contrato.nombre_contrato?.toLowerCase().includes(search) ||
        contrato.estado?.toLowerCase().includes(search) ||
        contrato.orden_compra?.toLowerCase().includes(search) ||
        contrato.tipo?.toLowerCase().includes(search) ||
        contrato.moneda?.toLowerCase().includes(search) ||
        contrato.monto?.toString().includes(search) ||
        contrato.duracion_meses?.toString().includes(search) ||
        cuenta?.nombre_empresa?.toLowerCase().includes(search) ||
        ejecutivo?.nombre?.toLowerCase().includes(search) ||
        ejecutivo?.apellido?.toLowerCase().includes(search)
      );
    });
  }


}

}
